<template>
  <div
    :style="{ backgroundImage: 'url(' + background + ')' }"
    class="container-fluid pt-4"
  >
    <b-container>
      <HMenu
        v-if="
          !(
            user.role === '230' ||
            user.role === '039' ||
            user.role === '056'
          ) 
        "
      />
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 text-white pt-3 pb-2 pl-4">
          <p class="stylingSmall4">Historial</p>
        </div>
      </div>
      <b-row>
        <b-col
          class="pila1 py-1"
          style="margin-bottom: 0.4em"
        >
          <div class="row">
            <div class="col-12 col-sm-12 pl-3 pt-2">
              <p class="stylingSmall3" style="margin-left: 0.1rem">Semana</p>
            </div>
          </div>
        </b-col>
      </b-row>


    <div v-if=" this.$route.params.depto != 'mantenimiento' &&  this.$route.params.depto != 'vigueta'  &&  this.$route.params.depto != 'bonogarantia'  &&  this.$route.params.depto != 'insulpanel'">
     <div class="semanas" v-if="this.historial.length > 0">
         <div v-for="(semana, key) in this.historial" :key="key">
             
             <div v-if="key ==0">
                <!--- INICIO --->
                    <b-row>
                        <b-col
                        class="bg-gris1 py-3"
                        style="margin-bottom: 0.4em"
                        >
                        <b-row class="px-4 py-2">
                            <b-col class="pila2">
                            <div class="row">
                                <div class="col-12 col-sm-12 pl-4 pt-1">
                                <p class="stylingSmall1" style="margin-left: 0.1rem">
                                    {{semana.semana}}
                                </p>
                                </div>
                            </div>
                            </b-col>
                        </b-row>
                        <b-row class="px-4 py-2">
                            <b-col class="bg-white pila mr-2">
                            <b-row>
                                <b-col cols="1" class="pr-0 pt-1"
                                ><div class="square" style="background-color: #ff4a4a"></div
                                ></b-col>
                                <b-col class="pl-3">
                                <p class="stylingSmall">Producción<br />semanal</p>
                                <h4 class="stylingH4G">{{semana.prod | rand}}</h4>
                                </b-col>
                            </b-row>
                            </b-col>

                            <b-col class="bg-white pila ml-1">
                            <b-row>
                                <b-col cols="1" class="pr-0 pt-1"
                                ><div class="square" style="background-color: #00c290"></div
                                ></b-col>
                                <b-col class="pl-3">
                                <p class="stylingSmall">Bono<br />Semanal</p>
                                <h4 class="stylingH4G">${{semana.bono | rand}}</h4>
                                </b-col>
                            </b-row>
                            </b-col>
                        </b-row>
                        </b-col>
                    </b-row>
                    <!--- FIN  --->

             </div>
             <div v-else>
                 <b-row>
                    <b-col
                    class="bg-gris py-3"
                    style="margin-bottom: 0.4em"
                    >
                    <b-row class="px-4 py-2">
                        <b-col class="pila2">
                        <div class="row">
                            <div class="col-12 col-sm-12 pl-4 pt-1">
                            <p class="stylingSmall1" style="margin-left: 0.1rem">
                                  {{semana.semana}}
                            </p>
                            </div>
                        </div>
                        </b-col>
                    </b-row>
                    <b-row class="px-4 py-2">
                        <b-col class="bg-white pila mr-2">
                        <b-row>
                            <b-col cols="1" class="pr-0 pt-1"
                            ><div class="square" style="background-color: #ff4a4a"></div
                            ></b-col>
                            <b-col class="pl-3">
                            <p class="stylingSmall">Producción<br />semanal</p>
                            <h4 class="stylingH4G">{{semana.prod | rand}}</h4>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col class="bg-white pila ml-1 mr-">
                        <b-row>
                            <b-col cols="1" class="pr-0 pt-1"
                            ><div class="square" style="background-color: #00c290"></div
                            ></b-col>
                            <b-col class="pl-3">
                            <p class="stylingSmall">Bono<br />Semanal</p>
                            <h4 class="stylingH4G">${{semana.bono | rand}}</h4>
                            </b-col>
                        </b-row>
                        </b-col>
                    </b-row>
                    </b-col>
                </b-row>
             </div>
            
            
         </div>
      </div>
      <div v-else> <!-- No hay registros -->
            <b-row>
                <b-col
                class="bg-gris1 py-3"
                style="margin-bottom: 0.4em"
                
                >
                <b-row class="px-4 py-2">
                    <b-col class="pila2">
                    <div class="row">
                        <div class="col-12 col-sm-12 pl-4 pt-1">
                        <p class="stylingSmall1" style="margin-left: 0.1rem">
                            Actualmente no se encuentran semanas registradas
                        </p>
                        </div>
                    </div>
                    </b-col>
                </b-row>
                
                </b-col>
            </b-row>
      </div>
    </div>
    <div v-else> <!-- Deptos que no llevan prod -->
        <div class="semanas" v-if="this.historial.length > 0">
         <div v-for="(semana, key) in this.historial" :key="key">
             
             <div v-if="key ==0">
                <!--- INICIO --->
                    <b-row>
                        <b-col
                        class="bg-gris1 py-3"
                        style="margin-bottom: 0.4em"
                        >
                        <b-row class="px-4 py-2">
                            <b-col class="pila2">
                            <div class="row">
                                <div class="col-12 col-sm-12 pl-4 pt-1">
                                <p class="stylingSmall1" style="margin-left: 0.1rem">
                                    {{semana.semana}}
                                </p>
                                </div>
                            </div>
                            </b-col>
                        </b-row>
                        <b-row class="px-4 py-2">

                            <b-col class="bg-white pila ml-1">
                            <b-row>
                                <b-col cols="1" class="pr-0 pt-1"
                                ><div class="square" style="background-color: #00c290"></div
                                ></b-col>
                                <b-col class="pl-3">
                                <p class="stylingSmall">Bono<br />Semanal</p>
                                <h4 class="stylingH4G">${{semana.bono | rand}}</h4>
                                </b-col>
                            </b-row>
                            </b-col>
                        </b-row>
                        </b-col>
                    </b-row>
                    <!--- FIN  --->

             </div>
             <div v-else>
                 <b-row>
                    <b-col
                    class="bg-gris py-3"
                    style="margin-bottom: 0.4em"
                    >
                    <b-row class="px-4 py-2">
                        <b-col class="pila2">
                        <div class="row">
                            <div class="col-12 col-sm-12 pl-4 pt-1">
                            <p class="stylingSmall1" style="margin-left: 0.1rem">
                                  {{semana.semana}}
                            </p>
                            </div>
                        </div>
                        </b-col>
                    </b-row>
                    <b-row class="px-4 py-2">
                    

                        <b-col class="bg-white pila ml-1 mr-">
                        <b-row>
                            <b-col cols="1" class="pr-0 pt-1"
                            ><div class="square" style="background-color: #00c290"></div
                            ></b-col>
                            <b-col class="pl-3">
                            <p class="stylingSmall">Bono<br />Semanal</p>
                            <h4 class="stylingH4G">${{semana.bono | rand}}</h4>
                            </b-col>
                        </b-row>
                        </b-col>
                    </b-row>
                    </b-col>
                </b-row>
             </div>
            
            
         </div>
        </div>
        <div v-else> <!-- No hay registros -->
                <b-row>
                    <b-col
                    class="bg-gris1 py-3"
                    style="margin-bottom: 0.4em"
                    
                    >
                    <b-row class="px-4 py-2">
                        <b-col class="pila2">
                        <div class="row">
                            <div class="col-12 col-sm-12 pl-4 pt-1">
                            <p class="stylingSmall1" style="margin-left: 0.1rem">
                                Actualmente no se encuentran semanas registradas
                            </p>
                            </div>
                        </div>
                        </b-col>
                    </b-row>
                    
                    </b-col>
                </b-row>
        </div>
    </div>
     
  
   

     
          <b-row>
                 <!-- v-if="!(user.role === '230' || user.role === '039' || user.role === '056')" -->
                <Footer v-if="!(user.role === '230' || user.role === '039' || user.role === '056')"
                :user="user"/> 
            </b-row>
      
    </b-container>
  </div>
</template>

<script>
import img from "../assets/fondoazul.png";
import ProgressBar from "../components/ProgressBar";
import Footer from "../components/Footer";
import DeptoBase from "../components/DeptoBase";
import HMenu from "../components/HeaderIcons";
import userService from "../services/user.service";
import "video.js/dist/video-js.css";

export default {
  name: "Historial",
  components: { ProgressBar, Footer, HMenu, DeptoBase },
  data: () => ({
    background: img,
  }),
  async created() {
    this.$store.dispatch("admin/week");
    await this.$store.dispatch("userService/getHistorial", this.$route.params);
    //console.log(this.historial);
  },
  async beforeMount() {
    let token = await this.$store.dispatch("userService/getToken");
    this.$store.dispatch("userService/decode", token);
  },

  computed: {
    week() {
      return this.$store.getters["admin/getWeek"];
    },
    user() {
      return this.$store.getters["userService/getIdentity"];
    },
    dataUrl() {
      let token = userService.getToken();
      let identity = userService.decode(token);
      return (
        "data:img/jpeg;base64," +
        btoa(
          new Uint8Array(identity.img.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        )
      );
    },
    historial() {
      return this.$store.getters["userService/getHistorial"];
    },
  },
  filters: {
    split: (value) => {
      if (!value) return "";
      value = value.toString();

      let splitStr = value.toLowerCase().split(" ");
      let len = splitStr.length;
      let i;

      for (i = 0; i < len; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      let nameCap = splitStr.join(" ");
      let newName = nameCap.split(" ").slice(0, -1).join(" ");

      return newName;
    },
    rand: (value) => {
      if (!value || value < 0) return "0";
      if (typeof value === "number") {
        return value.toFixed(2);
      }
      return value;
    },
    cap: (value) => {
      if (!value) return "";
      value = value.toString();

      let splitStr = value.toLowerCase().split(" ");
      let len = splitStr.length;
      let i;
      for (i = 0; i < len; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      let nameCap = splitStr.join(" ");
      return nameCap;
    },
  },
};
</script>
